module.exports = __webpack_public_path__ + "static/media/E-retirement.2e84590d.png";